import type { SxProps, Theme } from "@mui/material/styles";
import { DASHBOARD_PALETTE } from "./palette.token";

type DashPalette = typeof DASHBOARD_PALETTE;

function outlinedInputRootBase(dash: DashPalette) {
	return {
		bgcolor: dash.rowInset,
		borderRadius: 2,
		color: dash.textPrimary,
		fontFamily: '"Montserrat", sans-serif',
		"& fieldset": { borderColor: dash.cardBorder },
		"&:hover fieldset": { borderColor: dash.borderAccent },
		"&.Mui-focused fieldset": { borderColor: dash.accent, borderWidth: 1 },
	};
}

// Outlined TextField: dashboard palette, rowInset bg, accent focus border
export function dashOutlinedTextFieldSx(dash: DashPalette): SxProps<Theme> {
	return {
		"& .MuiOutlinedInput-root": outlinedInputRootBase(dash),
		"& .MuiInputBase-input::placeholder": {
			color: dash.textMuted,
			opacity: 1,
		},
		"& .MuiInputAdornment-root": {
			color: dash.muted,
			fontWeight: 600,
			fontSize: "0.8rem",
		},
	};
}

// Like dashOutlinedTextFieldSx with larger padding (login)
export function dashOutlinedTextFieldLargeSx(
	dash: DashPalette,
): SxProps<Theme> {
	return {
		"& .MuiOutlinedInput-root": {
			...outlinedInputRootBase(dash),
			py: 0.55,
			fontSize: "1rem",
		},
		"& .MuiInputBase-input::placeholder": {
			color: dash.textMuted,
			opacity: 1,
		},
		"& .MuiInputAdornment-root": {
			color: dash.muted,
			fontWeight: 600,
			fontSize: "0.8rem",
		},
		"& .MuiOutlinedInput-input": {
			py: 1.5,
		},
	};
}

// Primary gradient contained button (Reward, login, etc.)
export function dashPrimaryGradientButtonSx(dash: DashPalette): SxProps<Theme> {
	return {
		py: 1.35,
		borderRadius: 2,
		fontWeight: 700,
		textTransform: "none",
		fontSize: "0.95rem",
		letterSpacing: "0.06em",
		background: dash.gradientAccent,
		color: dash.textPrimary,
		boxShadow: `0 8px 24px rgba(100, 190, 230, 0.18)`,
		"&:hover": {
			background: dash.gradientAccent,
			filter: "brightness(1.08)",
			boxShadow: `0 10px 28px rgba(100, 190, 230, 0.22)`,
		},
		"&:disabled": {
			background: dash.skeletonBase,
			color: dash.muted,
			boxShadow: "none",
		},
	};
}
